export const lang = {
	signup: '立即注册',
	mobile: 'Email/手机号*',
	pass: '密码*',
	captchaSent: '验证码已发送',
	captchaSentSec: '{sec}秒后重新获取',
	captchaAgain: '重新获取验证码',
	captcha: '验证码',
	agree: '我已阅读并且同意',
	agreement: '注册协议',
	complete: '完成注册',
	signin: '已经有账号了? 去登录',
	enterMobile: '请输入Email/手机号',
	errorMobile: '手机号格式错误',
	enterPass: '请输入密码',
	passBits: '密码必须包含字母、数字和特殊字符，至少8个字符',
	enterCaptcha: '请输入验证码',
	getCaptcha: '滑动到最右边获取验证码',
	correctNum: '请输入正确的Email/手机号',
	slideBar: '请滑动验证条',
	read: '请先阅读并同意注册协议',
	successful: '注册成功请登录',
	success: '验证通过',
	用户注册协议:'用户注册协议',
	我知道了:'我知道了'
}